export const elementKeys = [
    "F1",
    "F2",
    "F3",
    "F4",
    "F5",
    "F6",
    "F7",
    "K",
    "OV",
];
export const emptyElements = elementKeys.reduce((acc, key) => {
    acc[key] = [];
    return acc;
}, {});
// export const RenderStruct:RenderStruct = {
//     vertices: [],
//     indices: [],
//     uvs: [],
//     material: [],
//     elements: structuredClone(emptyElements)
// }
// export const RenderStruct:RenderStruct = {
//     vertices: [],
//     indices: [],
//     uvs: [],
//     material: [],
//     elements: [],
//     group: ''
// }
